export default "__VITE_ASSET__BTc0QjDr__"